import { Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { forkJoin } from 'rxjs';
import { MonitorService } from 'src/app/shared/services/monitor.service';
import { BarGraphComponent } from 'src/app/shared/components/graph/bar-graph/bar-graph.component';

@Component({
  selector: 'app-device-xdr-top10-blocked',
  templateUrl: './device-xdr-top10-blocked.component.html',
  styleUrls: ['./device-xdr-top10-blocked.component.scss']
})
export class DeviceXdrTop10BlockedComponent implements OnInit {

  @Input() deviceId: any;
  @Input() xdrInfo_5m: any;

  // Bar datasets
  dnswatchData: any[] = [];
  attackData: any[] = [];
  spamData: any[] = [];
  geoipData: any[] = [];

  // states
  dnswatchState: string = "";
  attackState: string = "";
  spamState: string = "";
  geoipState: string = "";

  @ViewChildren(BarGraphComponent) barCharts!: QueryList<BarGraphComponent>;

  constructor(private api: MonitorService) {}

  ngOnInit(): void {
    this.loadState();
    this.loadRange("1h"); // default on page load
  }

  /** When user switches tabs */
  selectedTabChange(event: any) {
    const ranges = ["1h", "4h", "24h", "7d", "thisMonth", "lastMonth"];
    this.loadRange(ranges[event.index]);
  }

  loadState(){
    this.dnswatchState = this.xdrInfo_5m.DNSWatch_5m?.state ?? "";
    this.attackState = this.xdrInfo_5m.Attack_5m?.state ?? "";
    this.spamState = this.xdrInfo_5m.SPAM_5m?.state ?? "";
    this.geoipState = this.xdrInfo_5m.GeoIP_5m?.state ?? "";
  }

  /** API loader */
  loadRange(range: string) {
    forkJoin({
      dnswatch: this.api.getXdrTop(this.deviceId, range, "dnswatch"),
      attack:   this.api.getXdrTop(this.deviceId, range, "attack"),
      spam:     this.api.getXdrTop(this.deviceId, range, "spam"),
      geoip:    this.api.getXdrTop(this.deviceId, range, "geoip"),
    }).subscribe(res => {
      this.dnswatchData = this.mapBar(res.dnswatch || []);
      this.attackData   = this.mapBar(res.attack   || []);
      this.spamData     = this.mapBar(res.spam     || []);
      this.geoipData    = this.mapBar(res.geoip    || []);

      // redraw all canvas bars
      setTimeout(() => {
        this.barCharts?.forEach(c => c.redraw?.());
      }, 20);
    });
  }

  /** Map API → Bar chart structure */
 mapBar(rows: any[]): any[] {
  const list = rows
    .map((r: any[]) => ({ name: r[0], value: r[1] }))
    .sort((a, b) => b.value - a.value);

  if (list.length <= 10) return list;

  const top9 = list.slice(0, 9);
  //const other = list.slice(9);

  //const otherSum = other.reduce((a, x) => a + x.value, 0);

  return [
    ...top9,
    //{ name: "Other", value: otherSum }
  ];
}
}
